import { createReducer, on } from '@ngrx/store';
import {
  CHECKOUT_UPDATE_LOADING,
  CHECKOUT_SET_CURRENT_STEP,
  CHECKOUT_SET_PAYMENT_METHOD,
  CHECKOUT_UPDATE_CREDIT_CARD_FORM,
  CHECKOUT_PLACE_ORDER_SUCCESS,
  CHECKOUT_PLACE_ORDER_FAILURE,
  CHECKOUT_CLEAR_STATE,
  CHECKOUT_RESET_FORM,
  CHECKOUT_PLACE_ORDER,
  CHECKOUT_VALIDATE_ORDER
} from '../actions/checkout.actions';
import { PaymentMethodValid } from '@core/enums';
import { CreditCard } from '@/core/models';

export interface CheckoutState {
  currentStep: number;
  loading: boolean;
  error: string | null;
  paymentMethod: PaymentMethodValid.CASH | PaymentMethodValid.CARD;
  creditCardData: CreditCard | null;
}

export const initialCheckoutState: CheckoutState = {
  currentStep: 1,
  loading: false,
  error: null,
  paymentMethod: PaymentMethodValid.CASH,
  creditCardData: null
};

export const checkoutReducer = createReducer(
  initialCheckoutState,
  
  on(CHECKOUT_UPDATE_LOADING, (state, { loading }) => ({
    ...state,
    loading
  })),

  on(CHECKOUT_SET_CURRENT_STEP, (state, { currentStep }) => ({
    ...state,
    currentStep
  })),

  on(CHECKOUT_SET_PAYMENT_METHOD, (state, { paymentMethod }) => ({
    ...state,
    paymentMethod
  })),

  on(CHECKOUT_UPDATE_CREDIT_CARD_FORM, (state, { formData }) => {
    return {
    ...state,
    creditCardData: formData
  }
  }),

  on(CHECKOUT_PLACE_ORDER, CHECKOUT_VALIDATE_ORDER, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(CHECKOUT_PLACE_ORDER_SUCCESS, (state) => ({
    ...state,
    loading: false,
    error: null,
    currentStep: 1
  })),

  on(CHECKOUT_PLACE_ORDER_FAILURE, (state, { error }) => ({
    ...state,
    loading: false,
    error: typeof error === 'string' ? error : error?.message || 'Unknown error'
  })),

  on(CHECKOUT_RESET_FORM, (state) => ({
    ...state,
    paymentMethod: PaymentMethodValid.CASH,
    creditCardData: null
  })),

  on(CHECKOUT_CLEAR_STATE, () => initialCheckoutState)
);
